
/* eslint-disable no-warning-comments */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import React, {
    useContext, useCallback, useState, useEffect
} from 'react';
import { ViewModelServiceContext, ViewModelForm, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { withRouter } from 'react-router-dom';
import {QuoteWizardPageTemplate} from 'gw-capability-quoteandbind-common-react';
import {WizardPage, wizardProps} from '@xengage/gw-portals-wizard-react';
import {readViewModelValue} from '@xengage/gw-jutro-adapters-react';
import {FormattedMessage, useTranslator} from '@jutro/locale';
import { MLDriverVehicleUtil, MLNotificationBlockUtil, MLAvailableInsuredCandidatesUtil, MLWizardNavUtil } from 'ml-portals-util-react';
import { useModal } from '@jutro/components';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { UserService,MLProducerEligibilityService } from 'gw-capability-gateway';
import { LoadSaveService } from 'gw-capability-gateway-quoteandbind';
import { FormModalPopover, platformMessages } from 'ml-components-platform-react';
import { MLMultiLobsDataHolderService } from 'ml-services-common-react';
import { MLInsuredCandidatesComponent, MLNameDetailsComponent, MLPartialVehicleDetailsComponent } from 'ml-components-common-react';
import { EntityUtil, LocalDateUtil } from '@xengage/gw-portals-util-js';
import { MLModalService, MLTagManagerService } from 'ml-portals-services-react';
import _ from 'lodash';
import appConfig from 'app-config';
import PATrackEvent from 'gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/PATrackEvent';
import metadata from './GatewayPrefillPage.metadata.json5';
import messages from './GatewayPrefillPage.messages';
import styles from './GatewayPrefillPage.module.scss';
import addDriverMessages from '../../../gw-capability-quoteandbind-pa-react/pages/Prefill/AddDriverPopup.messages';
import addDriverMetadata from '../../../gw-capability-quoteandbind-pa-react/pages/Prefill/AddDriverPopup.metadata.json5';
import addDriverModalBodyStyles from '../../../gw-capability-quoteandbind-pa-react/pages/Prefill/AddDriverPopup.module.scss';
import removeDriverMessages from '../../../gw-capability-quoteandbind-pa-react/pages/Prefill/RemoveDriverPopup.messages';
import removeDriverMetadata from '../../../gw-capability-quoteandbind-pa-react/pages/Prefill/RemoveDriverPopup.metadata.json5';
import removeDriverModalBodyStyles from '../../../gw-capability-quoteandbind-pa-react/pages/Prefill/RemoveDriverPopup.module.scss';
import GatewayDriversPage from '../GatewayDriversPage/GatewayDriversPage';
import GatewayVehiclesPage from '../GatewayVehiclesPage/GatewayVehiclesPage';
import MLSpecialityListComponent from '../../components/MLSpecialityListComponent/MLSpecialityListComponent';
import { MLVehicleInfoLookupService } from 'ml-services-common-react';

import editDriverMessages from '../../../gw-capability-quoteandbind-pa-react/pages/Prefill/EditDriverPopup.messages';
import { AgentSelectionPopup } from 'gw-capability-quoteandbind-pa-react';
import SpecialtyVehiclesDetailsComponent from 'ml-components-common-react/AddSpecialtyVehiclesComponent/SpecialtyVehiclesDetailsComponent';

const ACTION_REMOVE_VEHICLE = 'remove';

const isQnB = appConfig.portalCode === 'QB';

const crDriversStep = {
    id: 'gwCompRaterDriversPage',
    title: messages.crDriversTitle,
    path: '/comp-drivers',
    component: GatewayDriversPage,
    mlStepName: 'compPaDrivers',
    ...(!isQnB && {
        stepProps: {
            template: QuoteWizardPageTemplate
        },
    })
};

const crVehiclesStep = {
    id: 'gwCompRaterVehiclesPage',
    title: messages.crVehiclesTitle,
    path: '/comp-vehicles',
    component: GatewayVehiclesPage,
    mlStepName: 'compPaVehicles',
    ...(!isQnB && {
        stepProps: {
            template: QuoteWizardPageTemplate
        },
    })
};

function GatewayPrefillPage(props) {
    const modalApi = useModal();
    const {
        wizardData: submissionVM,
        updateWizardData,
        goNext,
        isSkipping,
        currentStep,
        changeNextSteps,
        updateWizardSnapshot,
        steps,
        history
    } = props;
    const { canShowReturnToQuoteButton, isLastStep } = MLWizardNavUtil(props);
    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useTranslator();
    const { authHeader } = useAuthentication();
    const { refreshData } = useDataRefresh();
    const [vinErrorCheck, updateVinErrorCheck] = useState(undefined);

    const { nextStepVisited } = MLWizardNavUtil(props);

    const {
        showErrorModal,
        showProgressDialog,
        hideProgressDialog
    } = MLModalService();

    const {
        clearSuccessAlerts,
        clearBlockAlerts,
        addErrorAlert,
        addWarningAlert,
        addSuccessAlert,
        getNumberOfAlerts
    } = MLNotificationBlockUtil();

    const {
        readyVehicleForSave,
        validateVehicleAddition,
        validateAgentPrefillNextStep,
        validateDriverRemoval,
        getRatedDriverType,
        getHouseholdNonDriverType,
        getExcludedDriverType,
        isDriverRemovalAddHouseholdMember,
        isDriverRemovalAddRatedDriver,
        isDriverRemovalExclusion,
        getFullName,
        populateDriverPerson,
        validateDriverAddition,
        checkUniqueSelf,
        checkUniqueSpouse,
        getFilteredGender,
        getModernProductRemoveDriverOptions,
        readyDriverForSave,
        driverNotExcludedOrHousehold,
        getInsureDriver,
        isPrivatePassenger,
        isCollectible,
        isPartialVinWithoutSymbolsValid,
        isVehicleYearPost1980,
        isUnlistedModelValid,
        getRemoveDriverExcludedOptions,
        checkDriverRemovalCondition,
        checkIfNonDriver,
    } = MLDriverVehicleUtil();

    const {
        filterAvailableAutoInsuredCandidates,
        addRemovedDriverToAvailableCandidates
    } = MLAvailableInsuredCandidatesUtil();

    const [recentlyAddedVehicle, updateRecentlyAddedVehicle] = useState(null);
    const [recentlyAddedSpecialtyVehicle, updateRecentlyAddedSpecialtyVehicle] = useState(null);
    const [manuallyAddedSpecialtyVehicle, setManuallyAddedSpecialtyVehicle] = useState([]);
    const [isAddSpecialtyVehicleBtnEnabled, setIsAddSpecialtyVehicleBtnEnabled] = useState(true);
    // const [recentlyAddedDriver, updateRecentlyAddedDriver] = useState(null);
    // const [recentlyDeletedEntity, updateRecentlyDeletedEntity] = useState(null);

    // keep track of Add Vehicle Model
    const [isVehicleModalOpen, updateIsVehicleModalOpen] = useState(false);
    const [isSpecialityVehicleModalOpen, updateIsSpecialityVehicleModalOpen] = useState(false);
    const [isSpecialityVehicleModalEdit, updateIsSpecialityVehicleModalEdit] = useState(false);
    const [isVehicleModalEdit_Ext, updateIsVehicleModalEdit_Ext] = useState(false);
    const [isDriversDataInvalid, setIsDriversDataInvalid] = useState(false)
    const isGPA = appConfig.portalCode === 'GPA';
    const driversVMPath = 'lobData.personalAuto.coverables.drivers';
    const driversPath = 'lobData.personalAuto.coverables.drivers.value';
    const driverList = _.get(submissionVM, driversPath, []);
    const genderTypelist = viewModelService.productMetadata.get('pc').types.getTypelist('GenderType');
    const vehiclesValuePath = 'lobData.personalAuto.coverables.vehicles.value';
    const specialityVehicleListPath = 'lobData.personalAuto.specialtyCrossSell_ML.specialtyVehicles.value';
    const isSpecialityVehicleAvailablePath = 'lobData.personalAuto.specialtyCrossSell_ML.isCrossSellAvailable.value';
    const paModelVal = _.get(submissionVM, 'lobData.personalAuto.coverables.value', {});
    const isModernProduct = _.get(submissionVM, 'isModernProduct_Ext.value', false);

    const policyEffDate = _.get(submissionVM, 'baseData.periodStartDate.value');
    const bodyTypelist = viewModelService.productMetadata.get('pc').types.getTypelist('BodyType');
    const [showReturnToQuote, setShowReturnToQuote] = useState(false);
    const quoteStep = steps.find((step) => step.mlStepName === 'quoteDetails');
    const [canRequote, setCanRequote] = useState(false);
    const vehiclesPath = 'lobData.personalAuto.coverables.vehicles';
    const vehicleList = _.get(submissionVM, vehiclesValuePath, []);
    const [specialityVehicleList, setSpecialityVehicleList] = useState(_.get(submissionVM, specialityVehicleListPath, []))
    const [selectedSpecialities, setSelectedSpecialities] = useState([]);
    const SELF_TAG = 'self';
    const SPOUSE_TAG = 'spouse';

    const productTypelist = viewModelService.productMetadata.get("pc").types.getTypelist("SpecialtyProductType_Ext").codes;
    const productSubTypelist = viewModelService.productMetadata.get("pc").types.getTypelist("SpecialtyProductSubType_Ext").codes;
   const directRemoveStatuses = ['unknown', 'not_household', 'notresiding'];

    const SUBTYPE_TO_PRODUCTTYPE = {
      "Motorcycle": productTypelist.find(pt => pt.code === 'Motorcycle'),
      "ScooterMoped": productTypelist.find(pt => pt.code === 'Motorcycle'),
      "BoatWatercraft": productTypelist.find(pt => pt.code === 'Boat'),
      "Pontoon": productTypelist.find(pt => pt.code === 'Boat'),
      "PersonalWatercraft": productTypelist.find(pt => pt.code === 'Boat'),
      "ATVLicensed": productTypelist.find(pt => pt.code === 'OffRoadVehicle'),
      "ATVUnlicensed": productTypelist.find(pt => pt.code === 'OffRoadVehicle'),
      "DuneBuggy": productTypelist.find(pt => pt.code === 'OffRoadVehicle'),
      "GolfCartLicensed": productTypelist.find(pt => pt.code === 'OffRoadVehicle'),
      "GolfCartUnlicensed": productTypelist.find(pt => pt.code === 'OffRoadVehicle'),
      "LowSpeedVehicleLicensed": productTypelist.find(pt => pt.code === 'OffRoadVehicle'),
      "LowSpeedVehicleUnlicensed": productTypelist.find(pt => pt.code === 'OffRoadVehicle'),
      "OffRoadMotorcycle": productTypelist.find(pt => pt.code === 'OffRoadVehicle'),
      "Snowmobile": productTypelist.find(pt => pt.code === 'OffRoadVehicle'),
      "MotorHome": productTypelist.find(pt => pt.code === 'Motorhome'),
      "TrailerUtilityTrailer": productTypelist.find(pt => pt.code === 'TravelTrailer'),
    };

    // Initialize manually-added specialty vehicles from submissionVM so they persist across navigation
    useEffect(() => {
        const list = _.get(submissionVM, specialityVehicleListPath, []) || [];
        setSpecialityVehicleList(list);
        const manual = (list || []).filter((item) => item.source === 'Manual' || !!item.tempID);
        setManuallyAddedSpecialtyVehicle(manual);
    }, [submissionVM]);

    const crPrefillStepName = 'compPaPrefillResults';
    const rowEditableFor = ["DuneBuggy", "GolfCartLicensed", "GolfCartUnlicensed"];
    const [selectedProducerCode, setSelectedProducerCode] = useState('')
    const orderedRatedDriverList = () => {
        const unsortedRatedDrivers = driverList.filter((driver) => driverNotExcludedOrHousehold(driver));
        return _.sortBy(unsortedRatedDrivers, 'publicID');
    };

    const setCanRequoteFlag = useCallback(async () => {
        setCanRequote(showReturnToQuote && _.get(quoteStep, 'visited') !== true);
    }, [quoteStep, showReturnToQuote]);

    useEffect(() => {
        if (isGPA && !isSkipping) {
            UserService.getCurrentUser(authHeader).then((user) => {
                PATrackEvent('Quote Step Reached', isSkipping, submissionVM, user, { step: 'Prefill Results', ratedDriverList: orderedRatedDriverList(), vehiclesToDisplay: vehicleList });
            });
        }
        _.set(submissionVM, 'portalCurrentStep_ML.value', currentStep.mlStepName);
        canShowReturnToQuoteButton(submissionVM, authHeader, quoteStep).then((response) => {
            setShowReturnToQuote(!!response);
        });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        const sniPriorMailingAddressValue = _.get(submissionVM, 'baseData.sniPriorAddressQuestion_Ext.value', undefined)
        if (_.isUndefined(sniPriorMailingAddressValue)) {
            _.set(submissionVM, 'baseData.sniPriorAddressQuestion_Ext.value', false);
        }
        refreshData();
    }, []);

    useEffect(() => {
        driverList.forEach((driver) => {
            driver.editMode_ML = true;
            driver.isPolicyHolderOrPrefilledFlag_Ext = driver.isPolicyHolder || driver.fromPrefill_ML;
            readyDriverForSave(driver, LocalDateUtil.today());
            driver.pfmLevel_ML = submissionVM.baseData.pfmLevel_ML.value;
        });
        vehicleList.forEach((vehicle) => {
            vehicle.editMode_ML = true;
            vehicle.partialVehicleAdditionFlag_Ext = true;
        });
        refreshData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        setSelectedProducerCode(_.get(submissionVM, 'lobData.personalAuto.specialtyCrossSell_ML.selectedAgent.producerCode') ?? '')
    }, [submissionVM])

    useEffect(() => {
        const updatedList = _.get(submissionVM, specialityVehicleListPath, [])
        setSpecialityVehicleList(updatedList)
    }, [submissionVM])
    useEffect(() => {
        if (currentStep.mlStepName === 'compPaPrefillResults') {
            // Any driver or vehicle that isn't created from the bridging process will trigger the steps to show
            const isDriversStepVisible = driverList.some(driver => !driver.bridgedFromHVQ_ML);
            const isVehiclesStepVisible = vehicleList.some(vehicle => !vehicle.bridgedFromHVQ_ML);
            const driverStepIndex = steps.findIndex(step => step.mlStepName === 'compPaDrivers');
            const vehicleStepIndex = steps.findIndex(step => step.mlStepName === 'compPaVehicles');
            const validateInfoIndex = steps.findIndex(step => step.mlStepName === 'compPaValidateInfo');
            let remainingSteps = [];
            if (driverStepIndex > 0) {
                remainingSteps = steps.slice(driverStepIndex);
            } else if (vehicleStepIndex > 0) {
                remainingSteps = steps.slice(vehicleStepIndex);
            } else {
                remainingSteps = steps.slice(validateInfoIndex);
            }

            const newSteps = [];
            let updateNextSteps = false;
            if (isDriversStepVisible || isDriversDataInvalid) {
                if (driverStepIndex < 0) {
                    newSteps.push(crDriversStep);
                    updateNextSteps = true;
                }
            } 

            if (isVehiclesStepVisible) {
                if (vehicleStepIndex < 0) {
                    newSteps.push(crVehiclesStep);
                    updateNextSteps = true;
                }
            }
            if (updateNextSteps) {
                const nextSteps = newSteps.concat(remainingSteps);
                if (nextSteps[0].mlStepName === 'compPaVehicles' && nextSteps[1].mlStepName === 'compPaDrivers') {
                    [nextSteps[0], nextSteps[1]] = [nextSteps[1], nextSteps[0]];
                }
                changeNextSteps(nextSteps);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentStep.mlStepName, driverList, vehicleList, isDriversDataInvalid])

    useEffect(() => {
        setCanRequoteFlag();
    }, [setCanRequoteFlag, submissionVM]);

    

    const {
        onValidate,
        disregardFieldValidation,
        initialValidation
    } = useValidation('GatewayPrefillPage');

    const isModelValid = () => {
        return submissionVM.aspects.valid && submissionVM.aspects.subtreeValid;
    };

    const isSubmissionValid = () => {
        let isValid = true;
        const validationObj = validateAgentPrefillNextStep(submissionVM.value);
        if (_.isUndefined(submissionVM.baseData.sameMailingAddress_ML)) {
            // Prevents us to continue the quote if not defined. Should be defined in Start Quote page instead.
            submissionVM.baseData.sameMailingAddress_ML = true;
        }
        if (validationObj.hasError) {
            isValid = false;
            showErrorModal(messages.errorTitle, validationObj.errorMessage);
        }
        if (currentStep.mlStepName === 'compPaPrefillResults' && !checkUniqueSelf(driverList)) {
            isValid = false;
        }
        return isValid;
    };

    const getTypeKeyDescription = (typeKeyName) => {
        return translator({
            id: typeKeyName,
            defaultMessage: typeKeyName
        });
    };

    const clearEntityErrorMessage = (entity) => {
        if (entity.error) {
            entity.error.message = undefined;
        }
    };

    /**
     * Main Page
     */

    const hasDriversToShow = () => {
        return driverList.length > 0;
    };

    /**
     * Driver Actions
     */

    const initDrivers = () => {
        //
        // Create Driver if needed
        //
        const createDriverVM = () => {
            const primaryNamedInsured = submissionVM?.baseData?.primaryNamedInsured_ML?.value;
            const driverObj = {
                accidents: '0',
                violations: '0',
                lastName: primaryNamedInsured.firstName,
                firstName: primaryNamedInsured.lastName,
                dateOfBirth: primaryNamedInsured.dateOfBirth,
                isPolicyHolder: true,
                isPolicyHolderOrPrefilledFlag_Ext: true,
                licenseState: submissionVM.baseData.policyAddress.state.value.code,
                person: primaryNamedInsured,
                pfmLevel_ML: submissionVM.baseData.pfmLevel_ML.value,
                relationshipToInsured_ML: SELF_TAG,
                type_ML: getRatedDriverType()
            };
            const { _dtoName, _xCenter } = submissionVM.lobData.personalAuto.coverables.drivers;
            const driverVM = viewModelService.create(driverObj, _xCenter, _dtoName);
            submissionVM.lobData.personalAuto.coverables.drivers.pushElement(driverVM);
            return driverVM;
        };

        if (_.isEmpty(driverList)) {
            if (!_.isUndefined(submissionVM?.baseData?.primaryNamedInsured_ML?.value)) {
                createDriverVM();
            }
        }
    };

    initDrivers();

    const addAlertMessage = (objName, message, undoFunction, typeAlert, nameAlert, help) => {
        clearSuccessAlerts();
        let alertMessage = objName ? (
            <React.Fragment>
                <span role="alert" aria-live="polite">
                    <strong>{objName}</strong> {message}
                </span>
            </React.Fragment>
        ) : message;
        if (undoFunction) {
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            alertMessage = <React.Fragment>{alertMessage} <a role="button" tabIndex={0} onClick={undoFunction} onKeyDown={undoFunction}>Undo</a></React.Fragment>;
        }
        let alertFunc;
        if (typeAlert === 'success') {
            alertFunc = addSuccessAlert;
        } else if (typeAlert === 'error') {
            alertFunc = addErrorAlert;
        } else if (typeAlert === 'warning') {
            alertFunc = addWarningAlert;
        } else {
            alertFunc = addSuccessAlert;
        }
        const alertHelpTitle = help && help.title;
        const alertHelpMessage = help && help.message;

        alertFunc(alertMessage, nameAlert, undoFunction, alertHelpTitle, alertHelpMessage);
    };

    const countIsInvalid_Ext = (vm) => {
        let count = 0;
        vm.forEach((i) => {
            if (!i.aspects.valid || !i.aspects.subtreeValid) {
                count++;
            }
        });
        return count;
    };


    const updateInvalidPrefillBanner_Ext = (prefillItemInvalid) => {
        if (prefillItemInvalid) {
            if (getNumberOfAlerts('invalidPrefillItem') === 0 && !isVehicleModalOpen) {
                clearBlockAlerts('invalidPrefillItem');
                const errorMessage = translator(messages.prefillIncomplete_Ext);
                addAlertMessage(undefined, errorMessage, undefined, 'error', 'invalidPrefillItem');
            }
        } else if (getNumberOfAlerts('invalidPrefillItem') > 0 && !isVehicleModalOpen) {
            let errorCount = 0;
            errorCount += countIsInvalid_Ext(_.get(submissionVM, driversVMPath, []));
            errorCount += countIsInvalid_Ext(_.get(submissionVM, vehiclesPath, []));
            if (errorCount === 0 && checkUniqueSelf(driverList)) {
                clearBlockAlerts('invalidPrefillItem');
            }
        }
    };

    const resetPlaceholderObjs = () => {
        clearSuccessAlerts();
        // updateRecentlyDeletedEntity(null);
    };

    const setRemovedDriverToRated = (driver) => {
        const driversVM = _.get(submissionVM, `${driversVMPath}`);
        const foundDriver = driversVM.findFirstElement(driver);
        foundDriver.type_ML.value = getRatedDriverType();
        resetPlaceholderObjs();
    };

    const undoDriverRemoval = (driver) => {
        // paModel.undoRemovedDriverEntry();
        driverList.push(driver);
        setRemovedDriverToRated(driver);
    };

    const removeDriver = (driver, index) => {
        addRemovedDriverToAvailableCandidates(submissionVM, driver);
        submissionVM.value.lobData.personalAuto.coverables.removeDriver(driver);
        disregardFieldValidation(`driver${index}`);
        refreshData();
    };

    const removeDriverWithHistoryEvent = (driver, index) => {
        // updateRecentlyDeletedEntity(driver);
        removeDriver(driver, index);
        const msg = translator(removeDriverMessages.DriverHasBeenRemoved);
        addAlertMessage(getFullName(driver.person), msg, () => { undoDriverRemoval(driver); }, 'success', 'removedDriverNotHouse');
    };

    const removeDriverAddHouseholdMember = (driver) => {
        driver.type_ML = getHouseholdNonDriverType(driver, isModernProduct, submissionVM.baseData?.canExcludeDrivers_ML?.value, submissionVM.baseData.policyAddress.state.value.code);
        // updateRecentlyDeletedEntity(driver);
        driver.editMode_ML = false;
        let msg = translator(removeDriverMessages.DriverHasBeenAddedAsAHouseHoldMember);
        if (isModernProduct) {
            msg = translator(removeDriverMessages.DriverHasBeenAddedAsANonDriver);
        }
        addAlertMessage(getFullName(driver.person), msg, () => { setRemovedDriverToRated(driver); }, 'success', 'addedDriverHouseMember');
    };

    const removeDriverExclusion = (driverToExclude) => {
        driverToExclude.type_ML = getExcludedDriverType();
        // updateRecentlyDeletedEntity(driverToExclude);
        driverToExclude.editMode_ML = false;
        refreshData();
        const msg = translator(removeDriverMessages.DriverHasBeenExcluded);
        const help = {
            title: translator(removeDriverMessages.RemoveDriverExclusionHelpTitle),
            message: translator(removeDriverMessages.RemoveDriverExclusionHelpText)
        };
        addAlertMessage(getFullName(driverToExclude.person), msg, () => { setRemovedDriverToRated(driverToExclude); }, 'success', 'removedDriverExclusion', help);
    };

    const driverRemovalRules = (driverToRemove, index) => {
        clearBlockAlerts("invalidRemovalReason");
        if (_.isUndefined(driverToRemove.status_ML)) {
            driverToRemove.status_ML = "insure_driver";
        }
        if (
            isModernProduct &&
            directRemoveStatuses.includes(driverToRemove.status_ML)
        ) {
            removeDriver(driverToRemove, index);
        const msg = translator(removeDriverMessages.DriverHasBeenRemoved);
        addAlertMessage(getFullName(driverToRemove.person), msg, () => { undoDriverRemoval(driverToRemove); }, 'success', 'removedDriverNotHouse');
        } else if (driverToRemove.status_ML === "own_insurance" && submissionVM.baseData.policyAddress.state.value.code === "SC") {
            if (checkDriverRemovalCondition(submissionVM, driverToRemove)) {
                removeDriverAddHouseholdMember(driverToRemove, index);
            } else {
                removeDriverExclusion(driverToRemove);
            }
            return;
        } else if (driverToRemove.status_ML === "own_insurance" && isModernProduct) {
            if (checkIfNonDriver(driverToRemove)) {
                removeDriverAddHouseholdMember(driverToRemove, index)
            } else {
                removeDriverExclusion(driverToRemove);
            }
        }
        else if (isDriverRemovalAddHouseholdMember(driverToRemove, isModernProduct, submissionVM.baseData?.canExcludeDrivers_ML?.value, submissionVM.baseData.policyAddress.state.value.code)) {
            removeDriverAddHouseholdMember(driverToRemove, index);
        } else if (isModernProduct && driverToRemove.status_ML === "registeredowner" && submissionVM.baseData.policyAddress.state.value.code === "OR") {
            removeDriverAddHouseholdMember(driverToRemove, index);
        } else if (isDriverRemovalExclusion(driverToRemove, isModernProduct)) {
            removeDriverExclusion(driverToRemove);
        } else if (isDriverRemovalAddRatedDriver(driverToRemove)) {
            const errorMessage = translator(
                messages.notAValidReasonToRemoveThisDriver,
            );
            addAlertMessage(undefined, errorMessage, undefined, 'error', 'invalidRemovalReason');

        } else {
            removeDriverWithHistoryEvent(driverToRemove, index);
        }
    };

    const removeDriverButtonClick = (evt) => {
        const orderedDriverObj = orderedRatedDriverList()[evt.index];
        const driverVM = submissionVM.lobData.personalAuto.coverables.drivers.findFirstElement(orderedDriverObj);
        const driversOnSubmission = submissionVM.lobData.personalAuto.coverables.drivers;
        const driverName = getFullName(driverVM.value.person);
        const removeDriverModelTitle = `${translator(removeDriverMessages.remove)}`;

        _.set(driverVM, 'isPreparedToRemove_ML.value', true);
        _.set(driverVM, 'value.status_ML', null);

        const validateUniqueDriverRelationship_Ext = (code, message) => {
            if (driverVM.relationshipToInsured_ML.value && driverVM.relationshipToInsured_ML.value.code === code) {
                for (let i = 0; i < driversOnSubmission.length; i++) {
                    const driver = driversOnSubmission.value[i];
                    if (driver !== driverVM.value && driver.relationshipToInsured_ML && driver.relationshipToInsured_ML === code) {
                        return message;
                    }
                }
            }
        };

        const onRemoveDriverValidation = ({ value: driverToRemove }) => {
            const validationResult = validateDriverRemoval(driverToRemove, submissionVM.value);
            // If we already have validation errors, we shouldnt run this to avoid overwriting the values.
            if (!validationResult.hasError) {
                validationResult.errorMessage = validateUniqueDriverRelationship_Ext(SELF_TAG, translator(messages.selfSelected_Ext)) || validateUniqueDriverRelationship_Ext(SPOUSE_TAG, translator(messages.spouseSelected_Ext));
            }
            if (validationResult.hasError || validationResult.errorMessage) {
                return validationResult.errorMessage;
            }
            return true;
        };

        const onRemoveDriver = ({ value: driverToRemove }) => {
            driverRemovalRules(driverToRemove, evt.index);
            updateWizardData(submissionVM);

            UserService.getCurrentUser(authHeader).then((user) => {
                PATrackEvent('Cta Clicked', false, submissionVM, user, { action: 'Prefill Results Driver Removed', relationship: driverToRemove.relationshipToInsured_ML, reason: driverToRemove.status_ML, drivers: [driverToRemove] });
            });

            MLTagManagerService.sendFormStepEvent(MLTagManagerService.getFormName(), `${MLTagManagerService.getStepName()}_Remove Driver`);
            return true;
        };

        const getRemoveDriverReasonLabel = () => {
            return translator(removeDriverMessages.gpaReason, {
                name: driverName
            });
        };

        const onCancelRemoveDriver = () => {
            _.set(driverVM, 'isPreparedToRemove_ML.value', false);
        };
        const nbGenderStatePopup = _.get(submissionVM, 'baseData.isValidNonBinaryGenderState_Ext.value');
        let genderVisible = false;
        const genderValue = driverVM.gender.value == null;

        if(genderValue){
            genderVisible = true;
        }

        const componentProps = {
            title: removeDriverModelTitle,
            uiProps: removeDriverMetadata.pageContent,
            viewModel: driverVM,
            actionBtnLabel: translator(removeDriverMessages.removeDriver),
            cancelBtnLabel: translator(removeDriverMessages.cancel),
            modalBodyStyles: removeDriverModalBodyStyles,
            onSaveAction: onRemoveDriverValidation,
            showBannerMessage: true,
            discardChangesOnCancel: true,
            viewModelService,
            getOverrideProps: () => {
                return {
                    reason: {
                        label: getRemoveDriverReasonLabel(),
                        availableValues: isModernProduct ? getModernProductRemoveDriverOptions() : getRemoveDriverExcludedOptions()
                    },
                    // We're validating now using 'onRemoveDriverValidation' return value,
                    // using the built-in 'showBannerMessage' functionality in FormModalPopover.
                    errorNotification: {
                        visible: false
                    },
                    driverGender: {
                        path: 'gender',
                        visible: genderVisible,
                        availableValues: getFilteredGender(nbGenderStatePopup)
                    }
                };
            }
        };

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        ).then(onRemoveDriver, onCancelRemoveDriver);
    };

    const addNewRatedDriverModel = () => {
        const driverObj = {
            accidents: '0',
            violations: '0',
            tempID: EntityUtil.nextId()
        };
        driverObj.person = {
            tempID: EntityUtil.nextId(),
            primaryAddress: submissionVM.baseData.policyAddress.value,
            middleName: null
        };
        driverObj.licenseState = driverObj.person.primaryAddress.state;

        // set partialDriverAdditionFlag_ML to "true" to avoid requiredness for other fields
        driverObj.partialDriverAdditionFlag_ML = true;
        driverObj.type_ML = getRatedDriverType();
        driverObj.status_ML = getInsureDriver();
        driverObj.error = {
            message: null
        };
        driverObj.editMode_ML = true;
        // updateRecentlyAddedDriver(driverObj);

        const { _xCenter, _dtoName } = submissionVM.lobData.personalAuto.coverables.drivers;
        const driverVM = viewModelService.create(driverObj, _xCenter, _dtoName);

        MLTagManagerService.sendLinkClickEvent(`${MLTagManagerService.getStepName()}_Add Driver`);

        return driverVM;
    };

    const addDriverButtonClick = () => {
        filterAvailableAutoInsuredCandidates(submissionVM, driverList);
        // ctrl._clearValidationErrorMessage();
        const driverVM = addNewRatedDriverModel();
        const addDriverModelTitle = `${translator(addDriverMessages.AddDriverPopupTitle)}`;
        let validationErrorMessage = null;
        let showValidationError = false;
        let insuredCandidateSelectedML = false;
        const setInsuredCandidateSelectedML = (bool) => {
            insuredCandidateSelectedML = bool;
        };

        const onAddDriver = (driverToAddVm) => {
            const validationResult = validateDriverAddition(driverToAddVm.value, driverList);
            if (validationResult.hasError) {
                // recentlyAddedDriver.error.message = validationResult.errorMessage;
                return false;
            }
            if (!insuredCandidateSelectedML) {
                validationErrorMessage = translator(messages.selectDriver);
                showValidationError = true;
                return false;
            }
            populateDriverPerson(driverToAddVm.value);
            const msg = translator(messages.hasBeenAdded);
            addAlertMessage(getFullName(driverToAddVm.value.person), msg, undefined, 'success', 'addedDriver');
            // ctrl._clearEntityErrorMessage($scope.recentlyAddedDriver);
            // recentlyAddedDriver.editMode_ML = false;
            MLTagManagerService.sendFormStepEvent(MLTagManagerService.getFormName(), `${MLTagManagerService.getStepName()}_Add Driver`);

            submissionVM.lobData.personalAuto.coverables.drivers.pushElement(driverToAddVm);
            updateWizardData(submissionVM);
            refreshData();
            return true;
        };

        const nbGenderState = _.get(submissionVM, 'baseData.isValidNonBinaryGenderState_Ext.value');
        const componentProps = {
            title: addDriverModelTitle,
            uiProps: addDriverMetadata.pageContent,
            viewModel: driverVM,
            actionBtnLabel: addDriverMessages.addDriverLabel,
            cancelBtnLabel: addDriverMessages.cancelLabel,
            modalBodyStyles: addDriverModalBodyStyles,
            showBannerMessage: true,
            getOverrideProps: () => {
                return {
                    insuredCandidatesComponent: {
                        submissionVM,
                        driverVM,
                        driverType: getRatedDriverType(),
                        setInsuredCandidateSelected: setInsuredCandidateSelectedML,
                        partialDriverAdditionFlag: true,
                        viewModelService
                    },
                    formFieldsContainer: {
                        visible: insuredCandidateSelectedML
                    },
                    nameDetailsComponent: {
                        personVM: driverVM.person,
                        // to identify as a Compnent for FormModalPopover to attach onValidate function
                        isComponent: true
                    },
                    checkUniqueSelf: {
                        visible: driverList && !checkUniqueSelf([driverVM.value, ...driverList])
                    },
                    checkUniqueSpouse: {
                        visible: driverList && !checkUniqueSpouse([driverVM.value, ...driverList])
                    },
                    dobTooltipContainer: {
                        visible: false
                    },
                    errorNotification: {
                        visible: showValidationError && !insuredCandidateSelectedML
                    },
                    validationErrorMessage: {
                        content: validationErrorMessage
                    },
                    genderRow: {
                        availableValues: getFilteredGender(nbGenderState)
                    }
                };
            },
            customComponentResolvers: {
                mlInsuredCandidatesComponent: MLInsuredCandidatesComponent,
                mlnamedetailscomponent: MLNameDetailsComponent
            },
            onSaveAction: onAddDriver
        };

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        );
    };

    const checkCurrentAndMultipleSelf = (driverVM, driverList) => {
        if ((
            (driverVM?.relationshipToInsured_ML?.value && driverVM?.relationshipToInsured_ML?.value.code === SELF_TAG) ||
            (driverVM?.relationshipToInsured?.value && driverVM?.relationshipToInsured?.value.code === SELF_TAG)
        ) && !checkUniqueSelf(driverList)) {
            return true;
        }
        return false;
    };

    const editDriverButtonClick_Ext = (evt) => {
        const orderedDriverObj = orderedRatedDriverList()[evt.index];
        const driverVM = submissionVM.lobData.personalAuto.coverables.drivers.findFirstElement(orderedDriverObj);
        driverVM.editMode_ML.value = true;
        // driverVM.isPolicyHolderOrPrefilledFlag_Ext.value = false;

        const onCancelEditDriver = () => {
            driverVM.isPolicyHolderOrPrefilledFlag_Ext.value = driverVM.isPolicyHolder.value || driverVM.fromPrefill_ML.value;
            refreshData();
        };

        const onEditDriver = () => {
            if (checkCurrentAndMultipleSelf(driverVM, driverList)) {
                return '';
            }

            UserService.getCurrentUser(authHeader).then((user) => {
                PATrackEvent('Cta Clicked', false, submissionVM, user, { action: 'Prefill Results Driver Edited', drivers: [driverVM.value] });
            });

            updateWizardData(submissionVM);
            refreshData();
            return true;
        };

        const editDriverModelTitle = `${translator(editDriverMessages.editDriverPopupTitle_Ext)}`;
        const nbGenderState = _.get(submissionVM, 'baseData.isValidNonBinaryGenderState_Ext.value');
        const componentProps = {
            title: editDriverModelTitle,
            uiProps: addDriverMetadata.pageContent,
            viewModel: driverVM,
            actionBtnLabel: editDriverMessages.saveEditLabel_Ext,
            cancelBtnLabel: editDriverMessages.cancelLabel_Ext,
            modalBodyStyles: addDriverModalBodyStyles,
            discardChangesOnCancel: true,
            viewModelService,
            getOverrideProps: () => {
                return {
                    insuredCandidatesComponent: {
                        visible: false
                    },
                    nameDetailsComponent: {
                        personVM: driverVM.person,
                        isComponent: true,
                        disableNameFields: driverVM.isPolicyHolder?.value
                    },
                    checkUniqueSelf: {
                        visible: driverList && checkCurrentAndMultipleSelf(driverVM, driverList)
                    },
                    checkUniqueSpouse: {
                        visible: driverList && !checkUniqueSpouse(driverList)
                    },
                    dobTooltipContainer: {
                        visible: false
                    },
                    genderRow: {
                        availableValues: getFilteredGender(nbGenderState)
                    },
                    relationship: {
                        disabled: driverVM.isPolicyHolder?.value
                    }
                };
            },
            customComponentResolvers: {
                mlnamedetailscomponent: MLNameDetailsComponent
            },
            onSaveAction: onEditDriver,
            onCancelAction: onCancelEditDriver,
            showBannerMessage: true,
        };

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        );
    };

    const getGenderValue = (gender) => {
        if (gender === null || gender === undefined || gender === '') {
            return '';
        }
        const { name } = genderTypelist.getCode(gender);
        return getTypeKeyDescription(name);
    };

    const getDOBValue = (dob) => {
        if (dob === null || dob === undefined) {
            return '';
        }
        return `${(dob.month + 1)}/${dob.day}/${dob.year}`;
    };

    const getErrorCellClassNames = (item, isInvalid) => {
        const errorText = (item.error && item.error.message) || isInvalid ? 'error-help-text errorInline' : '';
        const grayStrike = item.removed ? 'graystrike' : '';
        return `cell font-weight-bold ${errorText} ${grayStrike}`;
    };

    const renderErrorCell_Ext = (cellContent, hasError) => {
        return (
            <span>
                {hasError ? <i className="icon-ml-alert-icon margin-right-5" /> : null}
                {cellContent}
            </span>
        );
    };

    const generateDriverListOverrides = () => {
        const driversVM = _.get(submissionVM, driversVMPath, []);
        const overrides = orderedRatedDriverList().map((drv, index) => {
            const driverVM = driversVM.findFirstElement(drv);
            const isMultipleSelfDrivers = checkCurrentAndMultipleSelf(driverVM, driverList);
            _.set(driverVM, 'editMode_ML.value', true);
            _.set(driverVM, 'partialDriverAdditionFlag_ML.value', true);
            const driverInvalid = !driverVM.aspects.valid || !driverVM.aspects.subtreeValid || isMultipleSelfDrivers;
            const driverHasError = !!_.get(drv, 'error.message') || driverInvalid;
            updateInvalidPrefillBanner_Ext(driverHasError);
            return {
                [`nameRow${index}`]: {
                    className: getErrorCellClassNames(drv, driverInvalid),
                    content: renderErrorCell_Ext(getFullName(drv.person), driverHasError)
                },
                [`dobRow${index}`]: {
                    className: drv.removed ? 'cell graystrike' : 'cell',
                    content: getDOBValue(drv.dateOfBirth)
                },
                [`genderRow${index}`]: {
                    className: drv.removed ? 'cell graystrike' : 'cell',
                    content: getGenderValue(drv.gender)
                },
                [`pfmRow${index}`]: {
                    className: drv.removed ? 'cell graystrike' : 'cell',
                    visible: !isModernProduct
                },
                [`driverEditItemLink${index}`]: {
                    'aria-labelledby': `driverEditItemLink${index} nameRow${index} dobRow${index} genderRow${index} pfmRow${index}`
                },
                [`driverRemoveItemLink${index}`]: {
                    visible: (!drv.removed),
                    'aria-labelledby': `driverRemoveItemLink${index} nameRow${index} dobRow${index} genderRow${index} pfmRow${index}`
                },
                [`driverUndoItemLink${index}`]: {
                    visible: !!drv.removed,
                    'aria-labelledby': `nameRow${index} dobRow${index} genderRow${index} pfmRow${index}`
                }
            };
        });

        return Object.assign({}, ...overrides);
    };

    // Vehicle Functions
    const hasVehiclesToShow = () => {
        return vehicleList.length > 0;
    };

    const onRemoveVehicleClick = (evt) => {
        if (evt.index >= 0) {
            const vehicle = vehicleList[evt.index];
            vehicle.removed = true;
            vehicle.editMode_ML = false;
            // updateRecentlyDeletedEntity(vehicle);
            // _.set(submissionVM, `${vehiclesValuePath}[${evt.index}]`, vehicle);
            // updateWizardData(submissionVM);
            // updateVehicleList((vehicles) => [...vehicles.slice(0, evt.index), vehicle, ...vehicles.slice(evt.index + 1)])

            UserService.getCurrentUser(authHeader).then((user) => {
                PATrackEvent('Cta Clicked', false, submissionVM, user, { action: 'Prefill Results Vehicle Removed', vehicles: [vehicle] });
            });

            updateWizardData(submissionVM);
            refreshData();
        }
        MLTagManagerService.sendFormStepEvent(MLTagManagerService.getFormName(), `${MLTagManagerService.getStepName()}_Remove Vehicle`);
    };

    const onUndoVehicleClick = (evt) => {
        if (evt.index >= 0) {
            const vehicle = vehicleList[evt.index];
            vehicle.removed = false;
            vehicle.editMode_ML = true;
            vehicle.partialVehicleAdditionFlag_Ext = true;
            // updateRecentlyDeletedEntity(null);
            // _.set(submissionVM, `${vehiclesValuePath}[${evt.index}]`, vehicle);
            // updateWizardData(submissionVM);
            // updateVehicleList((vehicles) => [...vehicles.slice(0, evt.index), vehicle, ...vehicles.slice(evt.index + 1)])
            refreshData();
        }
    };

    const removeVinIfNotNeeded = (vehicle) => {
        const categoriesWithoutVin = ['low_speed_vehicle', 'registered_golf_cart', 'trailer'];
        if (categoriesWithoutVin.includes(vehicle.category_ML)) {
            vehicle.vin = undefined;
        }
    };

    const handleCancelAddVehicle = useCallback(() => {
        paModelVal.removeVehicle(recentlyAddedVehicle);
        updateRecentlyAddedVehicle(null);
        _.set(submissionVM, vehiclesValuePath, paModelVal.vehicles);
    }, [paModelVal, updateRecentlyAddedVehicle, recentlyAddedVehicle, submissionVM]);

    const handleCancelEditVehicle = useCallback(() => {
        updateIsVehicleModalEdit_Ext(false);
        updateRecentlyAddedVehicle(null);
    }, [updateRecentlyAddedVehicle]);

    const getDefaultVehicleCategory = () => {
        return isModernProduct ? 'private_passenger_np' : 'private_passenger_light_truck';
    }

    const addNewVehicleModel = useCallback(() => {
        const pni = submissionVM.value.getPrimaryNamedInsured();

        // new vehicle being added to paModel
        const newVehicle = paModelVal.createVehicle(pni);
        newVehicle.isAgentCreated = true;
        newVehicle.error = { message: null };
        newVehicle.category_ML = getDefaultVehicleCategory();
        newVehicle.editMode_ML = true;
        newVehicle.partialVehicleAdditionFlag_Ext = true;

        updateRecentlyAddedVehicle(newVehicle);

        return newVehicle;
    }, [paModelVal, submissionVM]);

    const addNewSpecialtyVehicle = useCallback(() => {
        const specialtyVehicleVM = viewModelService.create({}, 'pc', 'metlife.edge.capabilities.crosssell.dto.SpecialtyVehicleDTOML')
        _.set(specialtyVehicleVM, 'productSubType', 'Motorcycle')
        _.set(specialtyVehicleVM, 'source', 'Manual')
        _.set(specialtyVehicleVM, 'tempID', EntityUtil.nextId())
        updateRecentlyAddedSpecialtyVehicle(specialtyVehicleVM);

        return specialtyVehicleVM;
    }, [viewModelService]);

    const cleanNonOwnedVehicles = useCallback(() => {
        const namedNonOwnerVehs = paModelVal.vehicles.filter((veh) => veh.namedNonOwner_ML === true);
        if (namedNonOwnerVehs.length > 0) {
            namedNonOwnerVehs.forEach((nonOwnerVeh) => {
                paModelVal.removeVehicle(nonOwnerVeh);
            });
        }
    }, [paModelVal]);

    const showVehicleModal = () => {
        updateIsVehicleModalOpen(true);
    };

    const showSpecialtyVehicleModal = () => {
        updateIsSpecialityVehicleModalOpen(true);
    }

    const editExistingVehicle = (evt) => {
        if (evt.index >= 0) {
            updateIsVehicleModalEdit_Ext(true);
            vehicleList[evt.index].editMode_ML = true;
            vehicleList[evt.index].partialVehicleAdditionFlag_Ext = true;
            updateRecentlyAddedVehicle(vehicleList[evt.index]);
            showVehicleModal();
        }
    };

    const setDefaultValueAmount = useCallback((vehicleVM) => {
        if (isModernProduct) {
            const valueMlAmount = _.get(vehicleVM, 'value_ML.amount.value', undefined);
            if (_.isUndefined(valueMlAmount)) {
                _.set(vehicleVM, 'value_ML.value', { amount: undefined });
            }
            if (vehicleVM.year?.value < 1981) {
                _.set(vehicleVM, 'bodyType_ML.value', undefined);
            }
        }
    }, [isModernProduct]);

    const getVehicleModal = () => {
        // check recentlyAddedVehicle for page refresh
        const editVehicle = recentlyAddedVehicle || addNewVehicleModel();

        cleanNonOwnedVehicles();

        const vehiclesVM = _.get(submissionVM, 'lobData.personalAuto.coverables.vehicles', {});
        const vehicleVM = vehiclesVM.findFirstElement(editVehicle);
        vehicleVM.isSerialNumberRequired_ML = false;
        setDefaultValueAmount(vehicleVM);

        const vehicleModelTitle = `${translator(isVehicleModalEdit_Ext ? messages.editModalTitle_Ext : messages.AddModalTitle)}`;

        const onSaveVehicleValidation = () => {
            const validationResult = validateVehicleAddition(vehicleVM.value, paModelVal.vehicles, policyEffDate);
            if (validationResult.hasError) {
                return validationResult.errorMessage;
            }
            return true;
        };

        const disableVehicleButton = (vm) => {
            return (isPrivatePassenger(vm.value) || isCollectible(vm.value)) && isVehicleYearPost1980(vm.value) && !isPartialVinWithoutSymbolsValid(vm.value)
                && !isUnlistedModelValid(vm);
        };

        const onSaveVehicle = () => {
            if (!isVehicleModalEdit_Ext) {
                const vehicleName = vehicleVM.value.getYearMakeModelNameML(translator);
                const msg = (<FormattedMessage
                    {...messages.vehicleHasBeenAdded}
                    values={{
                        vehicle: <b>{vehicleName}</b>
                    }}
                />);
                addSuccessAlert(msg, 'statusBarAlertInfo');
            }

            readyVehicleForSave(vehicleVM.value);
            clearEntityErrorMessage(vehicleVM.value);
            _.set(vehicleVM, 'editMode_ML.value', false);
            _.set(vehicleVM, 'partialVehicleAdditionFlag_Ext.value', false);
            _.set(vehicleVM, 'isCostNewRequired_ML.value', false);
            removeVinIfNotNeeded(vehicleVM.value);
            MLTagManagerService.sendFormStepEvent(MLTagManagerService.getFormName(), `${MLTagManagerService.getStepName()}_Add New Vehicle`);

            if (!isVehicleModalEdit_Ext) {
                const indexOfNewVehicle = paModelVal.vehicles.findIndex((v) => v.tempID === vehicleVM.value.tempID);
                if (indexOfNewVehicle === -1) {
                    paModelVal.vehicles.push(vehicleVM.value);
                } else {
                    paModelVal.vehicles[indexOfNewVehicle] = vehicleVM.value;
                }
            } else {
                UserService.getCurrentUser(authHeader).then((user) => {
                    PATrackEvent('Cta Clicked', false, submissionVM, user, { action: 'Prefill Results Vehicle Edited', vehicles: [vehicleVM.value] });
                });
            }
            _.set(submissionVM, vehiclesValuePath, paModelVal.vehicles);
            updateWizardData(submissionVM);

            // updateVehicleList((vehicles) => [...vehicles, vehicleVM.value]);

            // clear state
            updateIsVehicleModalOpen(false);
            updateIsVehicleModalEdit_Ext(false);
            updateRecentlyAddedVehicle(null);

            return true;
        };

        const componentProps = {
            title: vehicleModelTitle,
            CustomComponent: MLPartialVehicleDetailsComponent,
            viewModel: vehicleVM,
            showFooterOnCustomComponent: true,
            actionBtnLabel: translator(isVehicleModalEdit_Ext ? editDriverMessages.saveEditLabel_Ext : messages.addVehicleBtn),
            cancelBtnLabel: translator(messages.cancelBtn),
            isOpen: true,
            onSaveAction: onSaveVehicleValidation,
            onReject: () => {
                updateIsVehicleModalOpen(false);
                if (isVehicleModalEdit_Ext) {
                    handleCancelEditVehicle();
                } else {
                    handleCancelAddVehicle();
                }
            },
            onResolve: onSaveVehicle,
            overrideProps: {
                submissionVM: submissionVM,
                showProgressDialog,
                hideProgressDialog,
                isCompRaterQuote: !!submissionVM.hvqQuoteID_ML.value,
                viewModelService,
                updateVinErrorCheck,
                vinErrorCheck,
            },
            showBannerMessage: true,
            discardChangesOnCancel: isVehicleModalEdit_Ext,
            disableButton: disableVehicleButton,
            viewModelService
        };

        return (<FormModalPopover {...componentProps} />);
    };

    // In the getSpecialtyVehicleModal function, update the componentProps:

    const readySpecialtyVehicleForEdit = (veh) => {
        if (!veh) return;

        const vehicleForEdit =
            manuallyAddedSpecialtyVehicle.find((item) => item.tempID && veh.tempID && item.tempID === veh.tempID) ||
            specialityVehicleList.find((item) => (item.tempID && veh.tempID && item.tempID === veh.tempID) || (item.publicID && veh.publicID && item.publicID === veh.publicID));

        if (!vehicleForEdit) {
            return;
        }

        const vehicleVM = viewModelService.create(
            vehicleForEdit,
            'pc',
            'metlife.edge.capabilities.crosssell.dto.SpecialtyVehicleDTOML'
        );

        updateRecentlyAddedSpecialtyVehicle(vehicleVM);
        updateIsSpecialityVehicleModalEdit(true);
        updateIsSpecialityVehicleModalOpen(true);
    };

    const getSpecialtyVehicleModal = () => {
        const editVehicle = recentlyAddedSpecialtyVehicle || addNewSpecialtyVehicle();

        const onSaveSpecialtyVehicle = async () => {
            const subTypeCode =
                _.get(editVehicle, 'productSubType.value.code') ||
                _.get(editVehicle, 'productSubType.code') ||
                _.get(editVehicle, 'productSubType');

            const saved = {
                ...editVehicle.value,
                productType: _.get(SUBTYPE_TO_PRODUCTTYPE[subTypeCode], 'code'),
                productSubType: subTypeCode,
                make: _.get(editVehicle, 'make.value'),
                model: _.get(editVehicle, 'model.value')
            };

            const replaceOrAppend = (list = []) => {
                const index = list.findIndex((item) =>
                    (item.tempID && saved.tempID && item.tempID === saved.tempID) ||
                    (item.publicID && saved.publicID && item.publicID === saved.publicID)
                );

                return index >= 0
                    ? list.map((item, i) => (i === index ? saved : item))
                    : [...list, saved];
            };

            const nextManual = replaceOrAppend(manuallyAddedSpecialtyVehicle);
            const nextList = replaceOrAppend(specialityVehicleList);

            setManuallyAddedSpecialtyVehicle(nextManual);
            setSpecialityVehicleList(nextList);

            /*
            DE296585 if publicID is null or undefined for a manual vehicle
            Make backend call to create the vehicle -> without public id getIndicativeQuote is failing
            */
            if (_.isNil(saved.publicID)) {
                const resp = createSpecialtyVehicle(nextManual);
                showProgressDialog(resp.loading, resp)

                resp.then((r) => {
                    const respList = _.get(r, 'specialtyVehicles', []);

                    _.set(submissionVM, specialityVehicleListPath, respList);
                    setSpecialityVehicleList(respList);
                    updateWizardData(submissionVM);
                    refreshData();

                    // keep manual tracking aligned with server response
                    setManuallyAddedSpecialtyVehicle(
                        (respList || []).filter((item) => item.source === 'Manual' || !!item.tempID)
                    );
                }).catch((e) => {
                    console.log('Error creating specialty vehicle', e);
                    showErrorModal('', translator(messages.specialtyVehicleError))
                })
                
            } else {
                // Edit existing item only updates local VM/list for now
                _.set(submissionVM, specialityVehicleListPath, nextList);
                updateWizardData(submissionVM);
                refreshData();
            }

            updateIsSpecialityVehicleModalOpen(false);
            updateIsSpecialityVehicleModalEdit(false);
            updateRecentlyAddedSpecialtyVehicle(null);
            return true;
        };

        const title = isSpecialityVehicleModalEdit ? translator(messages.editSpecialtyVehicleTitle) : translator(messages.addSpecialtyVehicleTitle);

        const componentProps = {
            title: title,
            CustomComponent: SpecialtyVehiclesDetailsComponent,
            viewModel: editVehicle,
            showFooterOnCustomComponent: true,
            actionBtnLabel: isSpecialityVehicleModalEdit ? translator(messages.editSpecialtyVehicleBtn) : translator(messages.addSpecialtyVehicleBtn),
            cancelBtnLabel: translator(messages.cancelBtn),
            isOpen: true,
            // onSaveAction: onSaveSpecialtyVehicle,
            onReject: () => {
                updateIsSpecialityVehicleModalOpen(false);
                updateIsSpecialityVehicleModalEdit(false);
                updateRecentlyAddedSpecialtyVehicle(null);
            },
            onResolve: onSaveSpecialtyVehicle,
            disableButton: () => !isAddSpecialtyVehicleBtnEnabled,
            overrideProps: {
                viewModel: editVehicle,
                submissionVM: submissionVM,
                viewModelService,
                updateWizardData,
                translator: translator,
                isEditMode: isSpecialityVehicleModalEdit,
                setEnableSaveButton: setIsAddSpecialtyVehicleBtnEnabled
            },
            showBannerMessage: true,
            discardChangesOnCancel: true,
            viewModelService
        };

        return (<FormModalPopover {...componentProps} />);
    };

    // Redirect Function
    const handleStepAction = (redirectAction) => {
        if (!_.isEmpty(redirectAction)) {
            if (redirectAction.action === ACTION_REMOVE_VEHICLE) {
                onRemoveVehicleClick({ index: redirectAction.vehicleIndex });
            }
        }
    };

    useEffect(() => {
        setTimeout(() => {
            const element = document.getElementById("returnedContentP");
            if (element) {
                element.focus();
            }
        }, 100)
    }, []);

    useEffect(() => {
        const stepDataML = _.get(submissionVM, 'value.wizardActionDataML', {});
        if (!_.isEmpty(stepDataML)) {
            handleStepAction(stepDataML);
            _.set(submissionVM, 'value.wizardActionDataML', {});
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // End Redirect Functions

    useEffect(()=>{
        const selectedSpecialtiesArr = (specialityVehicleList ?? []).filter(item=>item?.isSelected ?? false) ?? []
        const selectedSpecialties = selectedSpecialtiesArr.map(item => item.publicID)
        setSelectedSpecialities(selectedSpecialties)
    }, [])

    // Override funtions
    const getBodyTypeValue = (bodyType) => {
        if (!_.isUndefined(bodyType)) {
            const { name } = bodyTypelist.getCode(bodyType);
            return getTypeKeyDescription(name);
        }
        return '';
    };

    const getStepInfo = () => {
        let nextStepName = (currentStep?.mlStepName === crPrefillStepName) ? 'compPaValidateInfo' : 'paDriverDetails';

        if (currentStep.mlStepName === crPrefillStepName) {

            const isDriversStepVisible = driverList.some(driver => !driver.bridgedFromHVQ_ML);
            const isVehiclesStepVisible = vehicleList.some(vehicle => !vehicle.bridgedFromHVQ_ML);

            if (isDriversStepVisible) {
                nextStepName = 'compPaDrivers';
            } else if (isVehiclesStepVisible) {
                nextStepName = 'compPaVehicles';
            }
        }

        return {
            currentStepName: currentStep?.mlStepName,
            nextStepName
        };
    }

    const nextStepText_Ext = () => {
        let formattedMessage;

        if (currentStep.mlStepName === crPrefillStepName) {
            const isDriversStepVisible = driverList.some(driver => !driver.bridgedFromHVQ_ML);
            const isVehiclesStepVisible = vehicleList.some(vehicle => !vehicle.bridgedFromHVQ_ML && !vehicle.removed);

            if (isDriversStepVisible) {
                formattedMessage = (
                    <FormattedMessage
                        {...messages.driversNext}
                        values={{
                            drivers: (
                                <strong>{translator(messages.drivers)}</strong>
                            )
                        }}
                    />
                );
            } else if (isVehiclesStepVisible) {
                formattedMessage = (<FormattedMessage
                    {...messages.vehiclesNext}
                    values={{
                        vehicles: (
                            <strong>{translator(messages.vehicles)}</strong>
                        )
                    }}
                />);
            } else {
                formattedMessage = (<FormattedMessage
                    {...messages.validationNext}
                    values={{
                        validate: (
                            <strong>{translator(messages.validate)}</strong>
                        )
                    }}
                />);
            }
        } else {
            formattedMessage = (<FormattedMessage
                {...messages.driversNext}
                values={{
                    drivers: (
                        <strong>{translator(messages.drivers)}</strong>
                    )
                }}
            />);
        }

        return formattedMessage;
    };

    const assignRegisteredOwnersToVehicles = (submissionVM) => {
        const coverables = _.get(submissionVM, 'lobData.personalAuto.coverables');
        if (!coverables) return;

        const drivers = _.get(coverables, 'drivers.children', []);
        const vehicles = _.get(coverables, 'vehicles.children', []);

        const selfDriver = _.find(
            drivers,
            d => _.get(d, 'relationshipToInsured_ML.value.code') === 'self'
        );

        const driverID = _.get(selfDriver, 'fixedId.value');
        if (!driverID) return;

        _.forEach(vehicles, vehicle => {
            const vehicleID = _.get(vehicle, 'fixedId.value');
            if (!vehicleID) return;

            const registeredOwners = _.get(vehicle, 'registeredOwners.value');

            if (_.isEmpty(registeredOwners)) {
                vehicle.registeredOwners = [{ driverID, vehicleID }];
            }
        });
    };

    const generateVehicleListOverrides = () => {
        const vehiclesVM = _.get(submissionVM, vehiclesPath, []);
        const overrides = vehicleList.map((veh, index) => {
            const vehicleVM = vehiclesVM.findFirstElement(veh);
            if (_.isUndefined(_.get(submissionVM, 'baseData.bypassCreditOrdering_Ext.value'))) {
                _.set(submissionVM, 'baseData.bypassCreditOrdering_Ext.value', false);
            }
            assignRegisteredOwnersToVehicles(submissionVM)
            const vehicleInvalid = !vehicleVM.aspects.valid || !vehicleVM.aspects.subtreeValid;
            updateInvalidPrefillBanner_Ext(vehicleInvalid);
            return {
                [`yearRow${index}`]: {
                    className: getErrorCellClassNames(veh, vehicleInvalid)
                },
                [`vehicleErrorIcon${index}`]: {
                    visible: !!_.get(veh, 'error.message') || vehicleInvalid
                },
                [`makeRow${index}`]: {
                    className: veh.removed ? 'cell graystrike' : 'cell'
                },
                [`modelRow${index}`]: {
                    className: veh.removed ? 'cell graystrike' : 'cell'
                },
                [`bodyTypeRow${index}`]: {
                    visible: !isModernProduct,
                    className: veh.removed ? 'cell graystrike' : 'cell'
                },
                [`bodyTypeContent${index}`]: {
                    visible: !isModernProduct,
                    content: getBodyTypeValue(veh.bodyType_ML)
                },
                [`trimRow${index}`]: {
                    className: veh.removed ? 'cell graystrike' : 'cell'
                },
                [`vinRow${index}`]: {
                    className: veh.removed ? 'cell graystrike vin-wrap' : 'cell vin-wrap'
                },
                [`removeItemLink${index}`]: {
                    visible: !veh.removed,
                    'aria-labelledby': `removeItemLink${index} yearRow${index} makeRow${index} modelRow${index} bodyTypeContent${index} trimRow${index} vinRow${index}`
                },
                [`editItemLink${index}`]: {
                    visible: !veh.removed,
                    'aria-labelledby': `editItemLink${index} yearRow${index} makeRow${index} modelRow${index} bodyTypeContent${index} trimRow${index} vinRow${index}`
                },
                [`undoItemLink${index}`]: {
                    visible: !!veh.removed,
                    'aria-labelledby': `undoItemLink${index} yearRow${index} makeRow${index} modelRow${index} bodyTypeContent${index} trimRow${index} vinRow${index}`
                }
            };
        });

        return Object.assign({}, ...overrides);
    };

    const onAgentSelectionSave = () => {
        console.log('save');
    }
    const onAgentSelectionCancel = () => {
        console.log('cancel');
    }

    const getPortalID = (header) => {
        const JWTToken = JSON.stringify(header);
        const token = JSON.parse(JWTToken).Authorization;
        const base64Url = token.split(".")[1];
        const base64 = base64Url.replace("-", "+").replace("_", "/");
        const result = JSON.parse(window.atob(base64));
        const portalId = (result?.farmers_portal_id) ? result.farmers_portal_id[0] : undefined;
        return portalId
    }

    const onIndicativeQuoteButtonClick = (e) => {
        e?.preventDefault()
        const portalID = getPortalID(authHeader)
        if (!portalID) {
            showErrorModal('', messages.foremostProducerSearchError);
            return;
        }
        const producersPromise = UserService.getFormostProducersForCrossSell(portalID, authHeader);

        showProgressDialog(producersPromise.loading, producersPromise);
        clearBlockAlerts('indicativeResponseError')
        producersPromise.then((response) => {
            if (_.isEmpty(response) || !Array.isArray(response)) {
                addErrorAlert(translator(messages.foremostProducerSearchError), 'indicativeResponseError');
                setTimeout(() => {
                    window.scrollTo(0, 0);
                }, 0);
                return;
            } else {
                if (response.length > 0) {
                    const producersList = response.map((item) => {
                        const agencyName = (item.firstName && item.lastName) ? `${item.firstName} ${item.lastName}` : `${item.portalUserName}`
                        return ({
                            ...item,
                            code: item.producerCode,
                            name: `${item.producerCode} ${agencyName}`
                        })
                    })

                    const componentProps = {
                        showBannerMessage: true,
                        discardChangesOnCancel: true,
                        CustomComponent: AgentSelectionPopup,
                        overrideProps: {
                            submissionVM,
                            viewModelService,
                            onNext,
                            updateWizardData,
                            selectedProducerCode,
                            setSpecialityVehicleList,
                            producersList: _.uniqBy(producersList, 'code'),
                            path: 'lobData.personalAuto.specialtyCrossSell_ML.selectedAgent.producerCode',
                        }
                    };
                    modalApi.showModal(<FormModalPopover {...componentProps} />)
                        .then(onAgentSelectionSave, onAgentSelectionCancel)
                }
            }
        }).catch((_error) => {
            addErrorAlert(translator(messages.indicativeResponseError), 'indicativeResponseError');
            setTimeout(() => {
                window.scrollTo(0, 0);
            }, 0);
            return;
        });
    }


    const onSpecialitySelectionChange = (item) => {
        const path = 'lobData.personalAuto.specialtyCrossSell_ML.specialtyVehicles.value'
        const updatedData = (specialityVehicleList ?? []).map((row, index) =>({
            ...row,
            isSelected: item.includes(index)
        }))
        _.set(submissionVM, path, updatedData)
        updateWizardData(submissionVM)
        setSelectedSpecialities(item)
    }

    const updateSubmissionVMOnBlur = (publicID, value, model) => {
        const path = 'lobData.personalAuto.specialtyCrossSell_ML.specialtyVehicles.value'
        const data = _.get(submissionVM, path, []) ?? []
        const updatedData = data.map((specialty) => {
            if (specialty.publicID === publicID) {
                return { ...specialty, [model]: value }
            }
            return { ...specialty }
        })
        _.set(submissionVM, path, updatedData)
        updateWizardData(submissionVM)
        setSpecialityVehicleList(updatedData)
    }

    const getDisabledSpecialties = useCallback(() => {
        const processedSpecialties = specialityVehicleList?.filter(item => item?.isProcessed ?? false)
        if (_.isEmpty(processedSpecialties)) return [];
        const types = _.uniq(processedSpecialties.map(speciality => speciality.productType)) ?? []

        return specialityVehicleList?.filter(item => (item?.isProcessed || types.includes(item.productType)) ?? false)?.map(obj => obj.publicID)
    }, [specialityVehicleList])

    const isGetIndicativeButtonDisabled = () => {
        if (!specialityVehicleList || specialityVehicleList?.length === 0 || selectedSpecialities?.length === 0) {
            return true;
        }
        const processedSpecialties = specialityVehicleList?.filter(item => item?.isProcessed ?? false)
        if (!_.isEmpty(processedSpecialties)) {
            const types = _.uniq(processedSpecialties.map(speciality => speciality.productType)) ?? []

            return specialityVehicleList?.filter(item => (!item?.isProcessed && !types.includes(item.productType)) ?? false).length <= 0
        }
        return false
    }

    const overrideProps = {
        nextDescription: {
            content: nextStepText_Ext()
        },
        noDriversDiv: {
            visible: !hasDriversToShow()
        },
        driverStackTableDiv: {
            visible: hasDriversToShow(),
            role: "table",
            "aria-describedby": "driverSectionHeader"
        },
        driversTableRowIterable: {
            data: orderedRatedDriverList()
        },
        ...generateDriverListOverrides(),
        noVehiclesDiv: {
            visible: !hasVehiclesToShow()
        },
        vehicleStackTableDiv: {
            visible: hasVehiclesToShow(),
            "aria-describedby": "vehicleSectionHeader"
        },
        tableRowIterable: {
            data: vehicleList
        },
        returnToQuoteButton: {
            visible: showReturnToQuote,
            disabled: !canRequote
        },
        ...generateVehicleListOverrides(),
        specialityVehicleSection: {
            visible: submissionVM?.value?.isPersonalAuto() && ['Draft', 'Quoted'].includes(submissionVM.baseData.status_ML?.value) && _.get(submissionVM, isSpecialityVehicleAvailablePath, false)
        },
        specialityVehicleButton: {
            onClick: onIndicativeQuoteButtonClick,
            disabled: isGetIndicativeButtonDisabled()
        },
        specialitySection: {
            specialityVehicles: specialityVehicleList.map(item => ({ ...item, isSelected: item?.isSelected ?? false })),
            updateSubmissionVMOnBlur,
            selectedSpecialities,
            onSpecialitySelectionChange,
            setSelectedSpecialities,
            rowEditableFor,
            rowDisabled: getDisabledSpecialties(),
            onReadySpecialtyVehicleForEdit: readySpecialtyVehicleForEdit
        },
        bodyTypeHeader: {
            visible: !isModernProduct
        },
        pfmHeader: {
            visible: !isModernProduct
        },
        addSpecialityVehicleButton: {
            disabled: specialityVehicleList.length >= 20
        },
        ...generateVehicleListOverrides()
    };

    const readValue = (id, path) => {
        return readViewModelValue(metadata.pageContent, submissionVM, id, path, overrideProps);
    };

    const validateData = useCallback((isReturnToQuote = false) => {
        const subValid = isSubmissionValid();
        const modelValid = isModelValid();

        if (isReturnToQuote && subValid && modelValid) {
            MLMultiLobsDataHolderService.storeFlowSteps(currentStep.mlStepName, 'quoteDetails', authHeader);
            const finalVehicles = paModelVal.vehicles.filter((v) => v.removed !== true);
            _.set(submissionVM, vehiclesValuePath, finalVehicles);
        }

        return subValid && modelValid;
    }, [authHeader, currentStep.mlStepName, isModelValid, isSubmissionValid, paModelVal.vehicles, submissionVM]);

    const getQuoteID = () => {
        return submissionVM.quoteID.value;
    };


    const hasPrefillVehicle = () => {
        if (isModernProduct) {
            const vehiclesVM = _.get(submissionVM, vehiclesPath, []);
            let count = 0;
            _.forEach(vehiclesVM.value, vehicle => {
                const isPrefillVehicle = _.get(vehicle, 'populatedByPrefill_ML');
                if (isPrefillVehicle) {
                    count++;
                }
            });
            if (count > 0) {
                return true;
            }
        }
        return false;
    };


    const orderReportsForPrefillVehicles = async (res) => {
        if (isModernProduct) {
            try {
                const jobNumber = getQuoteID();
                if (jobNumber) {
                    await MLVehicleInfoLookupService.orderReportsForPrefillVehicles(
                        jobNumber,
                        authHeader
                    );
                }
                const requestData = {
                    quoteID: submissionVM.quoteID.value,
                    postalCode: submissionVM.baseData?.policyAddress?.postalCode?.value?.substring(0, 5)
                };
                const submissionLoadPromise = LoadSaveService.retrieveSubmission(requestData, authHeader);
                try {
                    const sub = await submissionLoadPromise;
                    const subVM = viewModelService.create(sub, 'pc', 'edge.capabilities.quote.submission.dto.QuoteDataDTO');
                    _.set(res, 'lobData.personalAuto.coverables.vehicles', _.get(subVM, 'value.lobData.personalAuto.coverables.vehicles'));
                    // only backfill persons when res is missing it; never overwrite persons res already has
                    if (_.isEmpty(_.get(res, 'persons')) && !_.isEmpty(_.get(subVM, 'value.persons'))) {
                        _.set(res, 'persons', _.get(subVM, 'value.persons'));
                    }
                    return res
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error(error);
                }
            } catch (e) {
                // non-blocking failure
                console.warn('Failed to generate Prefill order report', e);
            }
        }
    }

    const createSpecialtyVehicle = async (vehicles) => {
        const quoteId = getQuoteID();
        const specialtyVehicleResponse = await LoadSaveService.createSpecialtyVehicleModel(
            quoteId,
            vehicles,
            authHeader
        );
        return specialtyVehicleResponse;
    };

    const handleEligibilityError = (data) => {
        clearBlockAlerts("producerEligibility");
        const defaultReason = translator(messages.selectDiffProducerCode);
        const reasonToShow = data.nonEligibleReason ? data.nonEligibleReason : defaultReason;
        addErrorAlert(translator(reasonToShow), 'producerEligibility');

    };

     const requestProducerEligibility = async() => {
        
        const req = {
            state: submissionVM.baseData.policyAddress.state.value.code,
            producerCodeCode: submissionVM.value.baseData.producerCode_ML,
            policyStatus: 'New',
            skipGroupEligibilityCheck : false
        };


        try{
            clearBlockAlerts("producercodechanged");
            
            const eligibilityPromise = MLProducerEligibilityService.isProducerCodeEligible(req, authHeader);
            showProgressDialog(platformMessages.checkingProducerCodeEligibility, eligibilityPromise);
            
            const data = await eligibilityPromise;

            if (!data.isEligible || !_.isUndefined(data.nonEligibleReason)) {
                handleEligibilityError(data);
                
                return false;
            }

            if(data.isEligible && req.producerCodeCode !== data.producerCodeCode){
                _.set(submissionVM,"value.baseData.producerCode_ML",data.producerCodeCode);
                _.set(submissionVM,"value.baseData.producerAutoUpdated_Ext",true);
                // Clear producerCodeOfRecord so sidebar will refetch fresh data
                _.set(submissionVM,"producerCodeOfRecord_ML.value",{});
                updateWizardData(submissionVM);
                const errorMessage = translator(messages.producerCodeChanged);
                addAlertMessage(undefined, errorMessage, undefined, 'warning', 'producercodechanged');
            }
        }catch(error){
            console.error(error);
            handleEligibilityError(error);
            return false;
        }
    };

    useEffect(() => {
        if(!skipOnResumeIf()){
            requestProducerEligibility();
        }
    }, []);

    const onNext = async () => {
        const stepInfo = getStepInfo();

        // handle some fields which might be emtpy due to not hitting the contact page
        if (stepInfo?.currentStepName === crPrefillStepName) {
            // handle missing bypassCreditOrdering_Ext
            if (_.isUndefined(_.get(submissionVM, 'baseData.bypassCreditOrdering_Ext.value'))) {
                const user = await UserService.getCurrentUser(authHeader);
                if (user?.primaryProducerCode_ML?.code?.startsWith('9SM')) {
                    _.set(submissionVM, 'baseData.bypassCreditOrdering_Ext.value', true);
                } else {
                    _.set(submissionVM, 'baseData.bypassCreditOrdering_Ext.value', false);
                }
            }

            // handle missing email address
            _.set(submissionVM, 'bypassValidationForComprater_Ext', true);

            // handle multiple policy  policy number
            const paModifiers = _.get(submissionVM, 'lobData.personalAuto.modifiers_ML.lineModifiers.value');
            if (paModifiers) {
                const multiplePolicyNumberModifier = paModifiers.find((modifier) => modifier.codeIdentifier_ML === 'PAMultiplePolicyHomePolicyNumber_ML');
                if (multiplePolicyNumberModifier) {
                    console.log('updating the multiple policy number')
                    multiplePolicyNumberModifier.chosenTermValue = '123456789'
                }
            }
        }

        if (isGPA) {
            const user = await UserService.getCurrentUser(authHeader);
            PATrackEvent('Quote Step Submitted', false, submissionVM, user, { step: 'Prefill Results', action: 'Prefill Results Submitted', ratedDriverList: orderedRatedDriverList(), vehiclesToDisplay: vehicleList });
        }

        if (!submissionVM.value.isQuoted()) {
            _.unset(submissionVM.value, 'bindData');
        }
        _.set(submissionVM, 'portalCurrentStep_ML.value', stepInfo.currentStepName);
        const canSkipSave = steps.some((step) => step.mlStepName === stepInfo.nextStepName && !!step.visited);

        // eslint-disable-next-line no-return-assign
        const isDataValid = await validateData();

        if (isDataValid) {
            const finalVehicles = paModelVal.vehicles.filter((v) => v.removed !== true);
            _.set(submissionVM, vehiclesValuePath, finalVehicles);
            const newSubmissionVM = viewModelService.clone(submissionVM); // .clone() is required to purge removed vehicles from the VM metadata

            try {
                let comPref;

                if (!!submissionVM.hvqQuoteID_ML.value && _.get(submissionVM, 'baseData.policyBillingDocCommPref_ML.value.code') === 'electronic') {
                    comPref = 'electronic'
                }

                if (!canSkipSave) {
                    showProgressDialog(platformMessages.saveSubmission);
                    let res = await LoadSaveService.updateDraftSubmission(newSubmissionVM.value, authHeader);

                    // DE212080 Prevent communication preference being reset to paper due to updateDraftSubmission call
                    if (comPref) {
                        _.set(res, 'baseData.policyBillingDocCommPref_ML', comPref);
                    }
                    
                    
                    let orderReportResult = await orderReportsForPrefillVehicles(res);

                    if(orderReportResult !== undefined){
                        newSubmissionVM.value = orderReportResult
                    }
                    else{
                    newSubmissionVM.value = res;
                    }

                    const driversVM = _.get(newSubmissionVM, driversVMPath, []);

                    driversVM?.children?.forEach((driver) => {
                        driver.editMode_ML.value = true;
                    });

                    const driversInvalid = !driversVM?.aspects?.valid || !driversVM?.aspects?.subtreeValid;
                    const failedFields = []; 
                    
                    driversVM?.children?.forEach((driver, driverIndex) => {  
                        Object.entries(driver).forEach(([fieldName, fieldVM]) => { 
                            if ( fieldVM &&  typeof fieldVM === 'object' &&  fieldVM.aspects &&  fieldVM.aspects.valid === false ) { 
                                failedFields.push({ 
                                    driverIndex, 
                                    fieldName
                                }); 
                            }
                        });
                    }); 

                    const nonEducationOccupationFailures = failedFields.filter( 
                        ({ fieldName }) =>  !['highestEducationLevel_Ext','occupation_Ext'].includes(fieldName)
                    ); 

                    if (driversInvalid && nonEducationOccupationFailures.length > 0) {
                        setIsDriversDataInvalid(true)
                        stepInfo.nextStepName = 'compPaDrivers';
                    }

                    MLMultiLobsDataHolderService.storeFlowSteps(stepInfo.currentStepName, stepInfo.nextStepName, authHeader);

                    if (!nextStepVisited()) {
                        return newSubmissionVM;
                    }

                    updateWizardSnapshot(newSubmissionVM);
                }
                goNext();
            } catch (error) {
                const bracketContent = error.baseError.match(/\[([^\]]+)\]/);
                if (error.baseError && error.baseError.includes('V214')) {
                    if (bracketContent) {
                        showErrorModal('', bracketContent[1], messages.closeWindow);
                    }
                    return false;
                } else if (error.baseError && error.baseError.indexOf('ConcurrentDataChangeException') > -1) {
                    hideProgressDialog();
                    showErrorModal(null, messages.somethingWentWrong)

                    return false;
                } else if(error.baseError){
                    if (bracketContent) {
                        showErrorModal('', bracketContent[1], messages.closeWindow);
                    }
                    return false;
                } else if(error.error.cause) {
                    hideProgressDialog();
                    showErrorModal(null, error.error.cause.message);
                    return false;
                } else {
                    throw error;
                }
            } finally {
                hideProgressDialog(platformMessages.saveSubmission);
            }
        }
        return false;
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            onValidate: onValidate,
            onNext: onNext,
            onAddVehicleClick: showVehicleModal,
            onAddSpecialityVehicleClick: showSpecialtyVehicleModal,
            onEditVehicleClick: editExistingVehicle,
            onRemoveVehicleClick,
            onUndoVehicleClick,
            undoDriverRemoval,
            onRemoveDriverButtonClicked: removeDriverButtonClick,
            onAddDriverButtonClicked: addDriverButtonClick,
            onEditDriverButtonClicked: editDriverButtonClick_Ext,
            onIndicativeQuoteButtonClick
        },
        resolveComponentMap: {
            mlSpecialityListComponent: MLSpecialityListComponent
        }
    };

    const skipOnResumeIf = () => {
        const jumpToQuote = _.get(history, 'location.state.jumpToQuote', false)

        if (jumpToQuote) {
            return initialValidation().then((isValid) => !!isValid);
        } else {        
            let lastVisitedStep = MLMultiLobsDataHolderService.getLastVisitedStep();

            if (!!_.get(submissionVM, 'bindData.policyNumber.value')
                && (submissionVM.value.baseData.status_ML === 'Bound' || submissionVM.value.baseData.status_ML === 'Binding')) {
                return true;
            }

            if (Array.isArray(lastVisitedStep)) {
                lastVisitedStep = lastVisitedStep[0];
            }
            // the casing of paPrefillData is inconsistant, so lowercasing it.
            if (lastVisitedStep?.toLowerCase() === 'paprefilldata' || lastVisitedStep === crPrefillStepName) {
                console.log(`Stopping on Prefill Page because lastVisitedStep is ${lastVisitedStep}`)
                return false;
            }

            if (lastVisitedStep === 'quoteDetails' &&
                submissionVM.hvqQuoteID_ML.value &&
                submissionVM.isBundle_ML.value) {
                return true;
            }

            if (submissionVM.isBundle_ML.value
                && submissionVM.baseData.status_ML.value !== 'Draft') {
                return true;
            }

            if (!isSubmissionValid()) {
                console.log('Stopping on Prefill page because of invalid submission')
                return false
            }

            if (!isModelValid()) {
                console.log('Stopping on Prefill page because of invalid model')
                return false
            }

            console.log('Skipping Prefill page because everything is valid')
            return true;
        }
    };

    return (
        <React.Fragment>
            <WizardPage
                skipWhen={skipOnResumeIf}
                showCancel={false}
                showPrevious={false}
                showNext={!nextStepVisited()}
                onNext={onNext}
                validateData={validateData}
                showReturnToQuote={showReturnToQuote && canRequote}
                disableReturnToQuote={!canRequote}
                updateWizardData={updateWizardData}
                history={history}
                nextLabel={translator(platformMessages.mlContinue)}
                showTextNextToButton={!nextStepVisited()}
                textNextToButton={nextStepText_Ext()}
                metadataPageId={!nextStepVisited() && _.get(metadata, 'pageContent.id')}
            >
                <ViewModelForm
                    uiProps={metadata.pageContent}
                    model={submissionVM}
                    overrideProps={overrideProps}
                    resolveValue={readValue}
                    callbackMap={resolvers.resolveCallbackMap}
                    componentMap={resolvers.resolveComponentMap}
                    classNameMap={resolvers.resolveClassNameMap}
                    onValidationChange={onValidate}
                />
            </WizardPage>
            {isVehicleModalOpen && getVehicleModal()}
            {isSpecialityVehicleModalOpen && getSpecialtyVehicleModal()}
        </React.Fragment>
    );
}

GatewayPrefillPage.propTypes = wizardProps;
export default withRouter(GatewayPrefillPage);